import { Component } from 'preact';

import AboutWeatherStation from '../../components/about/about-weather-station';
import AboutWebsite from '../../components/about/about-website';
import AboutContact from '../../components/about/about-contact';
import AboutDataUsage from '../../components/about/about-data-usage';
import AboutLicenses from '../../components/about/about-licenses';
import AboutMe from '../../components/about/about-me';
import AboutPhotos from '../../components/about/about-photos';
import Card from '../../components/card';
import style from './style.scss';
import PageTitle from '../../components/page-title';

class AboutPage extends Component {

	componentDidMount() {
		this.context.titleService.update('About');
		this.context.tracking.recordPageView();
	}

	render(props) {
		return (
			<div class={style.about}>
				<PageTitle>About Howick Weather Station</PageTitle>

				<div class={style.about_layout}>

					<div class={style.about_column}>
						<AboutWeatherStation />
						<AboutWebsite />
					</div>

					<div class={style.about_column}>
						<AboutMe />
						<AboutContact />
						<AboutDataUsage />
						<AboutLicenses />
					</div>

				</div>

				<Card cardTitle="Weather Station Location">
					<div class={style.map}>
						<div class={style.map_caption}>Map by Google</div>
					</div>
				</Card>

				<AboutPhotos />

			</div>
		);
	}

}

export default AboutPage;



// WEBPACK FOOTER //
// ./routes/about/index.js